/**
 * @generated SignedSource<<1f54c92be196aa9e470733926177b47c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CommentsModeEnum = "qa" | "standard" | "%future added value";
export type ResourceTypeEnum = "authorProfile" | "campaign" | "category" | "clientError" | "customStory" | "diningReport" | "embedStory" | "homepage" | "image" | "internalCategory" | "internalSuperCat" | "linkPost" | "loopNav" | "map" | "mmaEvent" | "mmaFight" | "mmaFighter" | "mmaPromotion" | "mmaWeightClass" | "neighborhood" | "package" | "page" | "post" | "product" | "productBrand" | "quickPost" | "redirect" | "series" | "startHere" | "stream" | "superCat" | "tag" | "vault" | "venue" | "videoGame" | "videoGamePlatform" | "videoPost" | "volumeVideo" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CskNavCommentCount_feedContentResource$data = {
  readonly authors: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly chorusId: number | null;
  readonly chorusUuid: string | null;
  readonly comments: {
    readonly enabled: boolean;
    readonly mode: CommentsModeEnum;
  };
  readonly globalId: string;
  readonly id: string;
  readonly permalink: string;
  readonly resourceType: ResourceTypeEnum;
  readonly title: string;
  readonly " $fragmentType": "CskNavCommentCount_feedContentResource";
};
export type CskNavCommentCount_feedContentResource$key = {
  readonly " $data"?: CskNavCommentCount_feedContentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"CskNavCommentCount_feedContentResource">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CskNavCommentCount_feedContentResource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permalink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourceType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorProfileResourceType",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentsType",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "FeedContentResourceInterface",
  "abstractKey": "__isFeedContentResourceInterface"
};

(node as any).hash = "c3c7e305a0bab721a084cd012fd2a366";

export default node;
